import * as React from 'react';
import { DisplayControlContext } from 'ui/common/display-control-context';
import styles from './group-panel.scss';
import { InfoText } from 'ui';
import { ComponentProps } from 'ui';

export const GroupPanel: React.FC<ComponentProps> = props => (
  <DisplayControlContext {...props}>
    {
      React.Children.count(props.children) ?
        <div className={styles.groupPanel}>
          <div className="row">{props.children}</div>
        </div>        
      : 
      <div className={styles.withoutChildren}/>
    }
    <InfoText {...props.info} />
    <InfoText {...props.infoLong} />
  </DisplayControlContext>
);
